import React from 'react'
import Signin from '../components/login/login'
function login() {
  return (
    <div>
      <Signin />
    </div>
  )
}

export default login
